import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import InPlaceImageUpload from 'components/form/in_place_image_upload';
import { AppUI } from '@seedlang/state';
import Text from 'components/text';
import styled from '@emotion/styled';
import Stack, { gaps } from 'components/layout/stack';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.lg};
  align-items: start;
  img {
    border-radius: 50%;
  }
`;

@observer
class SettingsUserImage extends React.Component {

  @computed get user() {
    return this.props.user || AppUI.user;
  }

  render() {
    return (
      <Wrapper>
        <Stack gap='sm'>
          <Text heading='3'>
            Change Profile Image
          </Text>
          <small>Image uploaded once selected — nothing more for you to do!</small>
        </Stack>
        <InPlaceImageUpload
          circle
          model='images'
          image={this.user.image}
          onChange={() => AppUI.loadUser()}
          querystring={{
            imageable_id: this.user.id,
            imageable_type: 'User',
          }}
        />
      </Wrapper>
    );
  }
}

export default SettingsUserImage;
